import { usePageTitle } from '@btime/react-hooks'
import React from 'react'

import { usePermalinkNavigation } from '../../../../utils/routes/permalinkNavigation'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import PageHeaderPanel from '../../../../components/presentation/PageHeaderPanel'
import TemplateRecordPdfPrintButton from '../../../../containers/templateRecords/TemplateRecordPdfPrintButton'

const PageHeader = ({ templateId }) => {
  const serviceOrder = useServiceOrder()
  const navigate = usePermalinkNavigation()
  const title = `BM`
  usePageTitle(title)

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/service-orders/${serviceOrder.id}/resume`)}
      title={title}
      mediumPadding
      noContainer
      side={<TemplateRecordPdfPrintButton name={title} recordId={11} templateId={templateId} noMargin />}
    />
  )
}

export default PageHeader
